import { call, put, takeLatest, delay, select, takeEvery } from "redux-saga/effects"
import { documentsService } from "../services/documents.services"
import { authHeader } from "../helpers/auth-header"
import Helpers from "../helpers/helpers"
import FileSaver from "file-saver"
import { clearMultibase } from "../actions/multiAiBase"
import axios from "../services/axios"
import {
	SET_PRIORITY_ACTION,
	BUILD_CONCEPT_UPDATE_DOCUMENT_PRIORITY,
	SEARCH_UPDATE_DOCUMENT_PRIORITY,
	TIMELINE_SEARCH_UPDATE_DOCUMENT_PRIORITY,
	VIEWDOCUMENTS_UPDATE_DOCUMENT_PRIORITY,
	SHOW_ALERT,
	LOGOUT,
	ADD_CUSTOM_TAGS,
	SET_PRIORITY_CUSTOM_TAG,
	UPDATE_CUSTOM_TAGS,
	REQUEST_CUSTOM_TAGS,
	DELETE_TAG,
	SET_DOCUMENT_DATE,
	HIDE_ALERT,
	BUILD_CONCEPT_UPDATE_DOCUMENT_DATE,
	SEARCH_UPDATE_DOCUMENT_DATE,
	TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE,
	HIDE_MODAL_ALERT,
	DOWNLOAD_DOCUMENT_FAQ,
	DOWNLOAD_DOCUMENT,
	START_DOWNLOAD,
	DOWNLOAD_PROGRESS,
	END_DOWNLOAD,
	DOWNLOAD_DOCUMENTS_OF_CONCEPT,
	ADD_COMMENT,
	DOCUMENT_RELOAD_COMMENTS_REQUEST,
	DELETE_COMMENT,
	DOWNLOAD_ZIP,
	START_BULK_DOWNLOAD,
	END_BULK_DOWNLOAD,
	UPDATE_FILE_TAG_SUCCESS,
	UPDATE_FILE_TAG_FAILED,
	UPDATE_FILE_TAG,
	DOWNLOAD_SINGLE_FILE,
	DOWNLOAD_MULTIPLE_FILE,
	GET_COMMENTS,
	DELETE_SINGLE_FILE,
} from "../types/index"
import { updateDocumentSearchPriority, updateSearchMetadata } from "../actions/searchActions"
import { updateConceptMetadata, updateDocumentPriority } from "../actions/buildconceptActions"
import { updateDocumentTimelimePriority, updateTimelineMetadata } from "../actions/createTimelineActions"
import { updateDocumentViewDocumentsPriority, updateViewDocumentMetadata } from "../actions/viewdocumentsActions"
import { clearLocalStorage, METADATA } from "../utils"
import {
	updateFileListComment,
	updateMetadataCommentCount,
	updateFileListTag,
	updateFileTagSuccess,
	updateFileTagFail,
} from "../actions/documentsActions"
import { updateDocumentModalComments } from "../actions/documentModalActions"
import { setNotification } from "../actions/notificationActions"
import { endDeleteAction, reloadList, startDeleteAction } from "../actions/deleteActions"

const deleteComment = async (id) => {
	return await axios.delete(`/file/comment/${id}`).catch((e) => console.log(e))
}

const setPriority = async (document_id, priority) => {
	return await axios.post(`/documents/tag?doc_id=${document_id}&tag_id=${priority}`).catch((e) => console.log(e))
}

const bulkDownload = async (documents_ids) => {
	return await axios.get(`/documents/download/zip?${documents_ids}`, { responseType: "blob" }).catch((e) => console.log(e))
}

const singleFileDownload = async (document_id) => {
	return await axios.get(`/file/download/${document_id}?native=false`, { responseType: "blob" }).catch((e) => console.log(e))
}

const downloadSingleFile = async (files_id, isAnnotation) => {
	const api = isAnnotation ? `/file/download/${files_id}?annotations=true&native=false` : `/file/download/${files_id}?native=false`
	return await axios.get(api, { responseType: "blob" }).catch((e) => console.log(e))
}

const downloadMultipleFile = async (files_ids) => {
	return await axios.get(`/file/download/zip${files_ids}?native=false`, { responseType: "blob" }).catch((e) => console.log(e))
}

const getCommentListByDocId = async (docId) => {
	return await axios.get("/file/comment/" + docId)
}

const deleteSingleFile = async (document_ids, isAnnotation) => {
	return await axios.delete(`/case/delete_file`, { data: document_ids }).catch((e) => console.log(e))
}

function* setPriorityActionFlow(action) {
	const { document_id, priority } = action.payload
	try {
		//Get from API
		// const response = await documentsService.setPriority(document_id,priority);
		const response = yield call(setPriority, document_id, priority)

		const tags = yield select((state) => state.tags.custom_tags.tags)
		const updatedTag = tags?.filter((tag) => tag.id === priority)

		if (response.status === 200) {
			yield put(updateDocumentPriority(document_id, updatedTag[0]))
			//yield put(updateDocumentSearchPriority(document_id, updatedTag[0]))
			//yield put(updateDocumentTimelimePriority(document_id, updatedTag[0]))
			yield put(updateDocumentViewDocumentsPriority(document_id, updatedTag[0]))
			yield put(updateFileListTag({ docId: document_id, data: updatedTag[0] }))
			//yield put(updateDocumentViewDocumentsPriority(document_id, updatedTag[0]))

			const data = {}
			data[METADATA.TAG] = updatedTag[0]?.id || ""
			yield put(updateSearchMetadata({ id: document_id, data: data }))
			yield put(updateTimelineMetadata({ id: document_id, data: data }))
			yield put(updateConceptMetadata({ id: document_id, data: data }))
			yield put(updateViewDocumentMetadata({ id: document_id, data: data }))
		} else {
			// dispatch(alertActions.showAlertAction({
			//     msg: 'There was an error. Please, try again',
			//     class: 'alert alert-danger'
			// }));
			let alert = {
				msg: "There was an error. Please, try again",
				class: "alert alert-danger",
			}
			yield put({
				type: SHOW_ALERT,
				payload: alert,
			})
		}
	} catch (error) {
		console.log(error)
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* setPriorityCustomTagActionFlow(action) {
	const state = yield select()
	const { priority, color, idTag, fileData } = action.payload
	try {
		//Get from API
		// const response = await documentsService.addEditTag(priority, color, idTag);
		const response = yield call(documentsService.addEditTag, priority, color, idTag)
		try {
			//Apply tag to file
			if (response?.data?.success === true) {
				if (response?.data?.tag?.id && fileData?.document_id) {
					yield put({
						type: UPDATE_FILE_TAG,
						payload: {
							...fileData,
							tag_id: response?.data?.tag?.id,
						},
					})
				}
			} else if (response?.data?.success === false) {
				yield put(
					setNotification({
						data: response?.data?.message,
						severity: "error",
					})
				)
			}

			if (response.data.status === "Tag Added.") {
				//Add new tag to reducer
				// dispatch(addTag(priority,color,response.data.tag_id));
				yield put({
					type: ADD_CUSTOM_TAGS,
					payload: {
						name: priority,
						color_id: color,
						id: response.data.tag_id,
					},
				})
			} else if (response.data.status === "Tag Updated.") {
				// dispatch(updateTag(priority,color,response.data.tag_id));
				yield put({
					type: UPDATE_CUSTOM_TAGS,
					payload: {
						name: priority,
						color_id: color,
						id: response.data.tag_id,
					},
				})
			}
			// dispatch(requestCustomTags());
			yield put({
				type: REQUEST_CUSTOM_TAGS,
			})
		} catch (e) {}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			} else if (error?.response?.status === 409 || 404) {
				// let alert = {
				// 	msg: error?.response?.data?.detail,
				// 	class: "alert alert-danger",
				// }
				// yield put({
				// 	type: SHOW_ALERT,
				// 	payload: alert,
				// })

				// yield delay(3000)

				// yield put({
				// 	type: HIDE_ALERT,
				// 	payload: null,
				// })

				yield put(
					setNotification({
						data: error?.response?.data?.detail || "something went wrong",
						severity: "error",
					})
				)

				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));

		// let alert = {
		// 	msg: "There was an error. Please, try again and check your connection",
		// 	class: "alert alert-danger",
		// }
		// yield put({
		// 	type: SHOW_ALERT,
		// 	payload: alert,
		// })
	}
}

function* deleteTagActionFlow(action) {
	const state = yield select()
	const { idTag } = action.payload
	try {
		//Get from API
		// const response = await documentsService.deleteTag(idTag);
		const response = yield call(documentsService.deleteTag, idTag)

		try {
			if (response.data.status === "Tag Added.") {
				//Add new tag to reducer
				// dispatch(requestCustomTags());
				yield put({
					type: REQUEST_CUSTOM_TAGS,
				})
			}
		} catch (e) {}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* setDocumentDateActionFlow(action) {
	const state = yield select()
	const { document_id, newdate } = action.payload
	try {
		// dispatch(alertActions.hideAlertAction());
		yield put({
			type: HIDE_ALERT,
			payload: null,
		})
		let newdateFormated = new Date(newdate).getTime()
		//Get from API
		// const response = await documentsService.setNewDateDocument(document_id,newdate);
		const response = yield call(documentsService.setNewDateDocument, document_id, newdate)
		//If success change state of current document priority
		if (response.data.success) {
			// dispatch(updateDocumentDate(document_id, newdateFormated));
			yield put({
				type: BUILD_CONCEPT_UPDATE_DOCUMENT_DATE,
				payload: { id: document_id, date: newdateFormated },
			})
			// dispatch(updateDocumentSearchDate(document_id, newdateFormated));
			yield put({
				type: SEARCH_UPDATE_DOCUMENT_DATE,
				payload: { id: document_id, date: newdateFormated },
			})
			// dispatch(updateDocumentTimelimeDate(document_id, newdateFormated));
			yield put({
				type: TIMELINE_SEARCH_UPDATE_DOCUMENT_DATE,
				payload: { id: document_id, date: newdateFormated },
			})

			const data = {}
			data[METADATA.DATE] = newdateFormated
			yield put(updateViewDocumentMetadata({ id: document_id, data: data }))
			// dispatch(alertActions.showAlertAction({
			//     msg: 'Document date changed',
			//     class: 'alert alert-success',
			//     type: 'modal'
			// }));
			yield put({
				type: SHOW_ALERT,
				payload: {
					msg: "Document date changed",
					class: "alert alert-success",
					type: "modal",
				},
			})
			// setTimeout(function(){
			//     dispatch(alertActions.hideModalAlertAction());
			// },7000);
			yield delay(7000)
			yield put({
				type: HIDE_MODAL_ALERT,
				payload: null,
			})
		} else {
			// dispatch(alertActions.showAlertAction({
			//     msg: 'There was an error. Please, try again',
			//     class: 'alert alert-danger'
			// }));
			yield put({
				type: SHOW_ALERT,
				payload: {
					msg: "There was an error. Please, try again",
					class: "alert alert-danger",
				},
			})
		}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* downloadDocumentFAQFlow() {
	try {
		try {
			var filename = "user_guide"
			// Helpers.httpRequest(
			//     `${window._env_.REACT_APP_API_URL}documents/faq`,
			//     'post',
			//     [],
			//     authHeader()
			// )
			// // 1. Convert the data into 'blob'
			// .then((response) => response.blob())
			// .then((blob) => {

			//     // 2. Create blob link to download
			//     const url = window.URL.createObjectURL(new Blob([blob]));
			//     const link = document.createElement('a');
			//     link.href = url;
			//     link.setAttribute('download', filename);
			//     // 3. Append to html page
			//     document.body.appendChild(link);
			//     // 4. Force download
			//     link.click();
			//     // 5. Clean up and remove the link
			//     link.parentNode.removeChild(link);

			// });
			yield call(documentsService.helpersDownloadDocumentFAQ, filename)
		} catch (error) {
			try {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					// dispatch(errorUser());
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
			} catch (e) {}
		}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* downloadDocumentActionFlow(action) {
	const state = yield select()
	const { document_id, title, source } = action.payload
	try {
		//Get from API
		try {
			// dispatch(startDownloadAction(document_id));
			yield put({
				type: START_DOWNLOAD,
				payload: document_id,
			})
			var filename = source
			if (filename === "") {
				filename = document_id
			}
			// Step 1: start the fetch and obtain a reader
			// let response = await fetch(
			//     `${window._env_.REACT_APP_API_URL}/documents/download/${document_id}`,
			//     Helpers.getConfig(
			//         'get',
			//         [],
			//     authHeader()
			//     ),
			//  ).catch(rejected => {
			// });
			let response = yield call(singleFileDownload, document_id)

			// Downloading file
			if (response.hasOwnProperty("data")) {
				let data = response.data
				let contentDisposition = response.headers["content-disposition"]
				let originalFinalName = contentDisposition ? contentDisposition.split("; ")[1].split("=")[1] || null : null
				let fileType = { type: response.headers["content-type"] }
				var blob = new Blob([data], fileType)
				FileSaver.saveAs(blob, originalFinalName || title)
			} else {
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
			}

			yield put({
				type: END_DOWNLOAD,
				payload: document_id,
			})

			// const reader = response.data.getReader();
			// // Step 2: get total length
			// const contentLength = +response.headers.get('Content-Length');
			// // Step 3: read the data
			// let receivedLength = 0; // received that many bytes at the moment
			// let chunks = []; // array of received binary chunks (comprises the body)
			// while(true) {
			// // const {done, value} = await reader.read();
			// const {done, value} = yield call (reader.read);
			// if (done) {
			//     break;
			// }
			// chunks.push(value);
			// receivedLength += value.length;
			// let percentage = ((receivedLength / contentLength) * 100).toFixed(2);
			// // dispatch(downloadProgressAction(document_id, percentage));
			// yield put ({
			//     type: DOWNLOAD_PROGRESS,
			//     payload: {id: document_id, percentage: percentage}
			// })
			// }
			// // Step 4: concatenate chunks into single Uint8Array
			// let chunksAll = new Uint8Array(receivedLength); // (4.1)
			// let position = 0;
			// for(let chunk of chunks) {
			// chunksAll.set(chunk, position); // (4.2)
			// position += chunk.length;
			// }
			// // Step 5: decode into a string
			// const url = window.URL.createObjectURL(new Blob([chunksAll]));
			// const link = document.createElement('a');
			// link.href = url;
			// link.setAttribute('download', filename);
			// // 3. Append to html page
			// document.body.appendChild(link);
			// // 4. Force download
			// link.click();
			// // 5. Clean up and remove the link
			// link.parentNode.removeChild(link);
			// dispatch(endDownloadAction(document_id));

			// yield put ({
			//     type: END_DOWNLOAD,
			//     payload: document_id
			// })
		} catch (error) {
			try {
				// dispatch(endDownloadAction(document_id));
				yield put({
					type: END_DOWNLOAD,
					payload: document_id,
				})
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					// dispatch(errorUser());
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
			} catch (e) {}
		}

		//If success change state of current document priority
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* downloadDocumentsOfConceptActionFlow(action) {
	const state = yield select()
	const { ext_id, description } = action.payload
	try {
		//Get from API
		try {
			// var filename = `${description}.zip`;
			// Helpers.httpRequest(
			//     `${window._env_.REACT_APP_API_URL}/documents/downloads/${description}`,
			//     'get',
			//     [],
			//     authHeader()
			//   )
			//   // 1. Convert the data into 'blob'
			//     .then((response) => response.blob())
			//     .then((blob) => {

			//         // 2. Create blob link to download
			//         const url = window.URL.createObjectURL(new Blob([blob]));
			//         const link = document.createElement('a');
			//         link.href = url;
			//         link.setAttribute('download', filename);
			//         // 3. Append to html page
			//         document.body.appendChild(link);
			//         // 4. Force download
			//         link.click();
			//         // 5. Clean up and remove the link
			//         link.parentNode.removeChild(link);
			//         document.getElementById('spinnerDownload').hidden = true;
			//         document.getElementById('btnMultipleDownload').disabled = false;
			//     });
			yield call(documentsService.helpersDownloadDocument, description)
		} catch (error) {
			document.getElementById("spinnerDownload").hidden = true
			document.getElementById("btnMultipleDownload").disabled = false
			try {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					// dispatch(errorUser());
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
			} catch (e) {}
		}
		//});

		//If success change state of current document priority
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* addCommentFlow(action) {
	const state = yield select()
	const { document_id, comment, comment_id } = action.payload
	try {
		// console.log("en addCommentTest action");
		// dispatch(alertActions.hideAlertAction());
		yield put({
			type: HIDE_ALERT,
			payload: null,
		})
		//Get from API
		// const response = await documentsService.addComment(document_id, comment, comment_id);
		const response = yield call(documentsService.addComment, document_id, comment, comment_id)
		//If success change state of current document priority
		if (response.data.success === true) {
			yield put({
				type: DOCUMENT_RELOAD_COMMENTS_REQUEST, //To do: understand this(reload comments) flow and refactor if needed
				payload: true,
			})
			yield put(
				setNotification({
					data: response?.data?.message,
					severity: "success",
				})
			)

			//get comment by doc id and update it store
			const comment = yield call(getCommentListByDocId, document_id)
			if (comment?.data?.success === true) {
				yield put(
					updateDocumentModalComments({
						data: comment.data.data,
						docId: document_id,
						count: comment.data.count,
					})
				)
				yield put(
					updateFileListComment({
						data: comment.data.data,
						docId: document_id,
					})
				)
				// yield put(updateMetadataCommentCount({
				//     count: comment.data.count,
				//     docId: document_id
				// }))
			}
		} else {
			let alert = {
				msg: "There was an error. Please, try again and check your connection",
				class: "alert alert-danger",
			}
			yield put({
				type: SHOW_ALERT,
				payload: alert,
			})
		}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* deleteCommentFlow(action) {
	const state = yield select()
	const { comment_id, document_id } = action.payload
	try {
		// dispatch(alertActions.hideAlertAction());
		yield put({
			type: HIDE_ALERT,
			payload: null,
		})
		// const response = await documentsService.deleteComment(comment_id);
		const response = yield call(deleteComment, comment_id)
		//If success change state of current document priority
		if (response.data.success === true) {
			// dispatch(updateCommentRequest(true));
			yield put({
				type: DOCUMENT_RELOAD_COMMENTS_REQUEST, //To do: understand this flow and refactor if needed
				payload: true,
			})

			//get comment by doc id and update it store
			const comment = yield call(getCommentListByDocId, document_id)
			if (comment?.data?.success === true) {
				yield put(
					updateDocumentModalComments({
						data: comment.data.data,
						docId: document_id,
						count: comment.data.count,
					})
				)
				yield put(
					updateFileListComment({
						data: comment.data.data,
						docId: document_id,
					})
				)
				// yield put(updateMetadataCommentCount({
				//     count: comment.data.count,
				//     docId: document_id
				// }))
			}
		} else {
			let alert = {
				msg: response.data.message || "There was an error. Please, try again and check your connection",
				class: "alert alert-danger",
			}
			yield put({
				type: SHOW_ALERT,
				payload: alert,
			})
		}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* downloadZipActionFlow(action) {
	const state = yield select()
	const { documents_id, source } = action.payload
	try {
		//Get from API
		try {
			var file = "zip"
			let documentList = ""

			yield put({
				type: START_BULK_DOWNLOAD,
				payload: true,
			})

			for (let index = 0; index < documents_id.length; index++) {
				if (index === 0) {
					documentList = "doc_ids=" + documents_id[index]
				} else {
					documentList = documentList + "&doc_ids=" + documents_id[index]
				}

				yield put({
					type: START_DOWNLOAD,
					payload: documents_id[index],
				})
			}

			var filename = source
			if (filename === "") {
				filename = "anzyz_documents"
			}

			let response = yield call(bulkDownload, documentList)
			if (response?.data) {
				const link = document.createElement("a")
				const url = URL.createObjectURL(response.data)
				link.href = url
				link.download = "documents.zip"
				link.click()
			} else {
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
			}

			yield put({
				type: END_BULK_DOWNLOAD,
				payload: false,
			})

			for (let index = 0; index < documents_id.length; index++) {
				yield put({
					type: END_DOWNLOAD,
					payload: documents_id[index],
				})
			}
		} catch (error) {
			console.log("error in download 1")
			console.log(error)
			try {
				// dispatch(endDownloadAction(documents_id));
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					// dispatch(errorUser());
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
			} catch (e) {
				console.log("error in download")
				console.log(e)
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
			}
		}

		//If success change state of current document priority
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {
			console.log("1")
			console.log(e)
		}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* downloadSingleDocumentActionFlow(action) {
	const state = yield select()
	const { document_id, title, source, isAnnotation } = action.payload
	try {
		//Get from API
		try {
			// dispatch(startDownloadAction(document_id));
			yield put({
				type: START_DOWNLOAD,
				payload: document_id,
			})
			var filename = source
			if (filename === "") {
				filename = document_id
			}
			let response = yield call(downloadSingleFile, document_id, isAnnotation)

			// Downloading file
			if (response?.hasOwnProperty("data")) {
				let data = response.data
				let contentDisposition = response.headers["content-disposition"]
				let originalFinalName = contentDisposition ? contentDisposition.split("; ")[1].split("=")[1] || null : null
				let fileType = { type: response.headers["content-type"] }
				var blob = new Blob([data], fileType)
				FileSaver.saveAs(blob, originalFinalName || title)
			} else {
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
				// yield put(
				// 	setNotification({
				// 		data: response?.data || "something went wrong",
				// 		severity: "error",
				// 	})
				// )
			}

			yield put({
				type: END_DOWNLOAD,
				payload: document_id,
			})
			// yield put(
			// 	setNotification({
			// 		data: response?.data || "something went wrong",
			// 		severity: "error",
			// 	})
			// )
		} catch (error) {
			try {
				yield put({
					type: END_DOWNLOAD,
					payload: document_id,
				})
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
				// yield put(
				// 	setNotification({
				// 		data: error?.response || "something went wrong",
				// 		severity: "error",
				// 	})
				// )
			} catch (e) {}
		}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
		// yield put(
		// 	setNotification({
		// 		data: error?.response || "something went wrong",
		// 		severity: "error",
		// 	})
		// )
	}
}

function* downloadMultipleDocumentActionFlow(action) {
	const state = yield select()
	const { documents_id, source } = action.payload
	try {
		//Get from API
		try {
			var file = "zip"
			let documentList = ""

			yield put({
				type: START_BULK_DOWNLOAD,
				payload: true,
			})

			for (let index = 0; index < documents_id.length; index++) {
				if (index === 0) {
					documentList = "?file_ids=" + documents_id[index]
				} else {
					documentList = documentList + "&file_ids=" + documents_id[index]
				}

				yield put({
					type: START_DOWNLOAD,
					payload: documents_id[index],
				})
			}

			var filename = source
			if (filename === "") {
				filename = "documents"
			}

			let response = yield call(downloadMultipleFile, documentList)
			if (response?.data) {
				const link = document.createElement("a")
				const url = URL.createObjectURL(response.data)
				link.href = url
				link.download = `${filename}.${file}`
				link.click()
				// yield put(
				// 	setNotification({
				// 		data: response?.data,
				// 		severity: "success",
				// 	})
				// )
			} else {
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
				// yield put(
				// 	setNotification({
				// 		data: response?.data || "something went wrong",
				// 		severity: "error",
				// 	})
				// )
			}

			yield put({
				type: END_BULK_DOWNLOAD,
				payload: false,
			})

			for (let index = 0; index < documents_id.length; index++) {
				yield put({
					type: END_DOWNLOAD,
					payload: documents_id[index],
				})
			}

			// yield put(
			// 	setNotification({
			// 		data: response?.data || "something went wrong",
			// 		severity: "error",
			// 	})
			// )
		} catch (error) {
			console.log("error in download 1")
			console.log(error)
			try {
				// dispatch(endDownloadAction(documents_id));
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					// dispatch(errorUser());
					yield put({
						type: LOGOUT,
						payload: null,
					})
					return
				}
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
			} catch (e) {
				console.log("error in download")
				console.log(e)
				let alert = {
					msg: "Download failed. There was an error",
					class: "alert alert-danger",
				}
				yield put({
					type: SHOW_ALERT,
					payload: alert,
				})
				yield delay(3000)
				yield put({
					type: HIDE_ALERT,
					payload: null,
				})
				// yield put(
				// 	setNotification({
				// 		data: response?.data || "something went wrong",
				// 		severity: "error",
				// 	})
				// )
			}
		}

		//If success change state of current document priority
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {
			console.log("1")
			console.log(e)
		}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* updateFileTag(action) {
	try {
		const response = yield call(documentsService.updateFileTag, action.payload)
		if (response?.data?.success === true) {
			yield put(updateFileTagSuccess(action.payload))
			yield put(
				setNotification({
					data: response?.data?.message,
					severity: "success",
				})
			)
		} else {
			yield put(updateFileTagFail({}))
			yield put(
				setNotification({
					data: response?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
		}
	} catch (error) {
		try {
			yield put(
				setNotification({
					data: error?.response?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)

			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* getDocumentComments(action) {
	try {
		const { document_id } = action?.payload
		//get comment by doc id and update it store
		const comment = yield call(getCommentListByDocId, document_id)
		if (comment?.data?.success === true && comment?.data?.data?.length > 0) {
			yield put(
				updateDocumentModalComments({
					data: comment.data.data,
					docId: document_id,
					count: comment.data.count,
				})
			)
			yield put(
				updateFileListComment({
					data: comment.data.data,
					docId: document_id,
				})
			)
			// yield put(updateMetadataCommentCount({
			//     count: comment.data.count,
			//     docId: document_id
			// }))
		}
	} catch (error) {
		try {
			if (error.response.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* deleteSingleDocumentActionFlow(action) {
	const { document_id, title, source, isAnnotation } = action.payload
	try {
		yield put(startDeleteAction(document_id))

		let result = yield call(deleteSingleFile, [document_id])

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(setNotification({ data: result?.data?.message, severity: "success" }))
			yield put(reloadList(true))
		} else {
			yield put(setNotification({ data: result?.data?.message, severity: "error" }))
		}
	} catch (error) {
		yield put(setNotification({ data: error, severity: "error" }))
	} finally {
		yield put(endDeleteAction(document_id))
	}
}

// Watches for the UPDATEACCOUNTDETAILS_REQUESTING action type
// When it gets it, it will call verificarFlow()
// WITH the action we dispatched
function* documentsWatcher() {
	// takeLatest() takes the LATEST call of that action and runs it
	// if we we're to use takeEvery, it would take every single
	// one of the actions and kick off a new task to handle it
	// CONCURRENTLY!!!
	yield takeLatest(SET_PRIORITY_ACTION, setPriorityActionFlow)
	yield takeLatest(SET_PRIORITY_CUSTOM_TAG, setPriorityCustomTagActionFlow)
	yield takeLatest(DELETE_TAG, deleteTagActionFlow)
	yield takeLatest(SET_DOCUMENT_DATE, setDocumentDateActionFlow)
	yield takeLatest(DOWNLOAD_DOCUMENT_FAQ, downloadDocumentFAQFlow)
	yield takeEvery(DOWNLOAD_DOCUMENT, downloadDocumentActionFlow)
	yield takeLatest(DOWNLOAD_DOCUMENTS_OF_CONCEPT, downloadDocumentsOfConceptActionFlow)
	yield takeLatest(ADD_COMMENT, addCommentFlow)
	yield takeLatest(DELETE_COMMENT, deleteCommentFlow)
	yield takeLatest(DOWNLOAD_ZIP, downloadZipActionFlow)
	yield takeLatest(UPDATE_FILE_TAG, updateFileTag)
	yield takeLatest(DOWNLOAD_SINGLE_FILE, downloadSingleDocumentActionFlow)
	yield takeLatest(DOWNLOAD_MULTIPLE_FILE, downloadMultipleDocumentActionFlow)
	yield takeLatest(GET_COMMENTS, getDocumentComments)
	yield takeLatest(DELETE_SINGLE_FILE, deleteSingleDocumentActionFlow)
}

export default documentsWatcher
